import React from "react";
import styled from "@emotion/styled";
import { Box, Flex, Heading, Text } from "theme-ui";
import { colors, typography } from "../../styles/theme";
import NavosHeroActions from "./NavosHeroActions";

const NavosHero = ({
  gradientType = 1,
  gradientVariant = "admin",
  showAskNavos = true,
}) => {
  const isLandingHero = gradientType === 1;

  return (
    <HeroWrapper gradientType={gradientType} gradientVariant={gradientVariant}>
      <Flex sx={heroStyles}>
        {isLandingHero ? (
          <>
            <Heading
              as="h1"
              sx={{
                ...typography.h1,
                textAlign: "center",
                mb: 0,
              }}
            >
              greytHR Support Center
            </Heading>

            <Text
              sx={{
                ...typography.textLg400,
                color: colors.neutral900,
                textAlign: "center",
              }}
            >
              Welcome to your intelligent knowledge base. Ask{" "}
              <Text as="span" sx={{ fontWeight: 600 }}>
                greytHR NAVOS
              </Text>{" "}
              your complex HR, payroll, or compliance questions and get precise
              answers in seconds.
            </Text>
          </>
        ) : (
          <>
            <Heading
              as="h1"
              sx={{
                ...typography.h1,
                textAlign: "center",
                mb: 0,
              }}
            >
              Get instant answers with <br />
              <Text sx={{ color: colors.primary700 }}>greytHR NAVOS</Text>
            </Heading>

            <Text
              sx={{
                ...typography.textLg400,
                color: colors.neutral900,
                textAlign: "center",
              }}
            >
              Experience real-time support anytime
            </Text>
          </>
        )}

        <NavosHeroActions
          showAskNavos={showAskNavos}
          customStyles={{ mt: ["0.5rem", "0.5rem", "2rem", "2rem"] }}
        />
      </Flex>
    </HeroWrapper>
  );
};

export default NavosHero;

const { heroStyles } = {
  heroStyles: {
    flexDirection: "column",
    alignItems: "center",
    gap: ["1rem", "1rem", "1.25rem", "1rem"],
    maxWidth: "52rem",
    mx: "auto",
  },
};

const HeroWrapper = styled(Box)`
  background: ${({ gradientType, gradientVariant }) =>
    getGradients(gradientType, gradientVariant).mobile};
  padding: 7rem 2rem;
  text-align: center;

  @media (max-width: 599px) {
    padding: 3rem 1rem;
  }

  @media (min-width: 900px) {
    background: ${({ gradientType, gradientVariant }) =>
      getGradients(gradientType, gradientVariant).desktop};
  }
`;

const getGradients = (gradientType, gradientVariant) => {
  if (gradientType === 1) {
    return GRADIENTS_TYPE_1;
  }

  return GRADIENT_VARIANTS[gradientVariant] || GRADIENT_VARIANTS.admin;
};

const GRADIENTS_TYPE_1 = {
  mobile: `
    linear-gradient(
      180deg,
      #fffbf5 0%,
      #fff8ec 25%,
      #f8f0ff 60%,
      #f3e8ff 100%
    )
  `,
  desktop: `
    radial-gradient(
      ellipse 50% 100% at 50% 50%,
      #ffeed0 0%,
      #fff8ec 30%,
      #f5ebff 65%,
      #f0e4ff 100%
    )
  `,
};

const GRADIENT_VARIANTS = {
  admin: {
    mobile: `
      linear-gradient(
        180deg,
        #fff3dc 0%,
        #fff8ec 20%,
        #fffbf5 45%,
        ${colors.white} 100%
      )
    `,
    desktop: `
      radial-gradient(
        ellipse 32% 55% at 50% 30%,
        #fff0cc 0%,
        #fff5dc 25%,
        #fffbf0 55%,
        ${colors.white} 100%
      )
    `,
  },
  "ess-web": {
    mobile: `
      linear-gradient(
        180deg,
        ${colors.secondaryBlue200} 0%,
        ${colors.secondaryBlue100} 20%,
        ${colors.secondaryBlue100} 45%,
        ${colors.white} 100%
      )
    `,
    desktop: `
      radial-gradient(
        ellipse 32% 55% at 50% 30%,
        ${colors.secondaryBlue200} 0%,
        ${colors.secondaryBlue100} 25%,
        ${colors.secondaryBlue100} 55%,
        ${colors.white} 100%
      )
    `,
  },
  "ess-mobile": {
    mobile: `
      linear-gradient(
        180deg,
        ${colors.secondaryGreen400} 0%,
        ${colors.secondaryGreen200} 20%,
        ${colors.secondaryGreen100} 45%,
        ${colors.white} 100%
      )
    `,
    desktop: `
      radial-gradient(
        ellipse 32% 55% at 50% 30%,
        ${colors.secondaryGreen400} 0%,
        ${colors.secondaryGreen200} 25%,
        ${colors.secondaryGreen100} 55%,
        ${colors.white} 100%
      )
    `,
  },
};
